import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import $ from 'jquery';

import groupLeader from '../../../svg/group-leader.svg';
import { Row, Col } from '../../Grid';
import { CancelButton, CanceledButton } from './Common';
import ModalQuestion from '../../ModalQuestion';
import { cancelGroup } from '../../../redux/offers';
import GroupList from '../Partials/GroupList';

const InstanceContainer = styled.div`
  background-color: #cceef0;
  height: 40px;
  margin-bottom: 2px;
`;

const Title = styled.div`
  line-height: 42px;
  margin-left: 5px;
  display: inline-block;
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  letter-spacing: normal;
  color: #333333;
`;

const GroupInfo = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  line-height: 40px;
  text-decoration: underline;
  letter-spacing: normal;
  color: #333333;
  cursor: pointer;
`;

interface Props {
  group: Group;
  type: string;
  offerId: string;
  cancelGroup: Function;
}

function GroupOfferView({ offerId, group, type, cancelGroup }: Props) {
  const cancelId = `cancelGroup${group.id}`;

  return (
    <InstanceContainer>
      <ModalQuestion
        title="Cancel Group?"
        leftName="NO"
        rightName="YES"
        id={cancelId}
        function={() => {
          cancelGroup(offerId, group.id);
        }}
      >
        This will cancel a group
        <br /> of {group.confirmed}, organized by
        <br />
        <div>
          <img src={groupLeader} alt="" />
          <Title>
            {group.owner.first_name} {group.owner.last_name}
          </Title>
        </div>
      </ModalQuestion>
      <Row>
        <GroupList group={group} id={'group-' + group.id} offerId={offerId} />
        <Col size="0 0 270px">
          <div>
            <img src={groupLeader} style={{ marginLeft: '40px' }} alt="" />
            <Title>
              {group.owner.first_name} {group.owner.last_name}
            </Title>
          </div>
        </Col>
        <Col size="1">
          <GroupInfo onClick={() => $(`#group-${group.id}`).modal('show')}>
            {group.confirmed}{' '}
            {group.status === 'cancelled' || group.status === 'finalized' ? 'Claims' : 'Confirmed'}
            {group.uncertain !== 0 && ` | ${group.uncertain} Pending`}
          </GroupInfo>
        </Col>

        {group.status !== 'cancelled' ? (
          type !== 'past' ? (
            <Col
              size="0 0 10px"
              onClick={() => {
                $('#' + cancelId).modal('show');
              }}
            >
              <CancelButton />
            </Col>
          ) : null
        ) : (
          <Col size="0 0 109px">
            <CanceledButton>CANCELLED</CanceledButton>
          </Col>
        )}
      </Row>
    </InstanceContainer>
  );
}

export default connect(null, { cancelGroup })(GroupOfferView);
